// Entry for every other page (start, content, checkout, account, .com country entry).

import Alpine from 'alpinejs';
import './common.js';

// account
import '../account/accountOrder.js';
import '../account/guestPassword.js';
import '../account/customerCard.js';
import '../account/returnPortal.js';

// Widgets used by checkout, account, and the .com country entry page
import '../navigation/countryEntry.js';

// locations of the pickup address
import '../locations/pickupAddress.js';
import '../locations/packstationSearch.js';

// checkout
import '../checkout/basketPage.js';
import '../checkout/paymentStep.js';
import '../checkout/klarnaPayment.js';
import '../checkout/adyenMethod.js';
import '../checkout/unzerMethod.js';
import '../checkout/delayedPayment.js';
import '../checkout/amazonPayCheckout.js';
import '../checkout/paypalExpress.js';
import '../checkout/reservationCheckout.js';
import '../checkout/checkoutSteps.js';
import '../checkout/stickyBasket.js';
import '../checkout/voucherForm.js';
import '../checkout/giftCardField.js';

// forms of the address and registration steps
import '../forms/addressPicker.js';
import '../forms/addressCheck.js';
import '../forms/checkoutRegistration.js';
import '../forms/newsletterOptions.js';
import '../forms/birthdate.js';
import '../forms/filialeSelect.js';

// Must stay last: Alpine only starts after every alpine:init registration above has run.
// setTimeout keeps the DOM walk out of this bundle's evaluation task (TBT).
setTimeout(() => Alpine.start(), 0);
